









import { Component, Mixins, Prop } from "vue-property-decorator";

@Component
export default class FatalIndicator extends Mixins() {
  @Prop()
  message: string;

  @Prop()
  id: string;

  get errorMessage(): string {
    return "指定されたオブジェクト(ID:" + this.id + ")にアクセスできません。" +
      (!!this.message ? this.message + "です。" : "");
  }

  showErrorInfo(): void {
    this.$error("ID指定エラー", this.errorMessage);
  }

  get shouldShow(): boolean {
    return this.$configuration.behavior.wizard.editor.shouldShowNotImplemented;
  }
}
